import { render, staticRenderFns } from "./VBaseMultiSelect.vue?vue&type=template&id=0019dbac&scoped=true"
import script from "./VBaseMultiSelect.vue?vue&type=script&lang=ts"
export * from "./VBaseMultiSelect.vue?vue&type=script&lang=ts"
import style0 from "./VBaseMultiSelect.vue?vue&type=style&index=0&id=0019dbac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019dbac",
  null
  
)

export default component.exports